import { ImageCropper } from '@/components/imageCropper/imageCropper';
import React, { useEffect, useState } from 'react';
import { Button, Dialog, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface CropImageModalProps {
  file?: File | null;
  setFile: (value: File | null) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  aspectRatio?: number;
  mimeType?: string;
  quality?: number;
}

export const CropImageModal: React.FC<CropImageModalProps> = ({
  open,
  setOpen,
  file,
  setFile,
  aspectRatio,
  mimeType,
  quality,
}) => {
  const refDialog = React.useRef({ open: () => ({}), dismiss: () => ({}) });
  const [imageUrl, setImageUrl] = useState('');
  const [croppedImage, setCroppedImage] = useState<Blob | null>(null);

  const originalDimenssion = {
    width: 970,
    height: 500,
  };
  const [imageDimenssion, setImageDimenssion] = useState(originalDimenssion);

  function getImageDimensions(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
        URL.revokeObjectURL(url);
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  useEffect(() => {
    open ? refDialog.current.open() : refDialog.current.dismiss();
  }, [open]);

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file);
      getImageDimensions(file).then(({ width, height }) => {
        setImageDimenssion({
          width: Math.min(width, originalDimenssion.width),
          height: Math.min(height, originalDimenssion.height),
        });

        setTimeout(() => {
          setImageUrl(url);
        }, 100);
      });

      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [file, originalDimenssion.height, originalDimenssion.width]);

  return (
    <Dialog
      elevation={4}
      instanceEmitter={refDialog.current}
      outlined
      rounded
      size={1000}
      onClose={() => setOpen(false)}
      head={<Text size='larger' textAlign='center' title value='Recortar imagem' />}
      footer={
        <Grid alignContent='right'>
          <Button
            solo
            label='Cancelar'
            onClick={() => {
              setFile(null);
              setOpen(false);
            }}
          />
          <Button
            label='Confirmar'
            onClick={() => {
              const fileName = file ? file.name : 'cropped_image.png';
              setFile(
                croppedImage
                  ? new File([croppedImage], fileName, { type: croppedImage.type })
                  : null,
              );
              setOpen(false);
            }}
          />
        </Grid>
      }>
      <Grid column alignContent='center' alignItems='center' gap={8}>
        <ImageCropper
          imageUrl={imageUrl}
          maxHeight={imageDimenssion.height}
          maxWidth={imageDimenssion.width}
          onCropBlob={setCroppedImage}
          aspectRatio={aspectRatio}
          mimeType={mimeType}
          quality={quality}
        />
      </Grid>
    </Dialog>
  );
};
